import { Builder as FetchBuilder } from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
const fetchReports = () => {
  const promise = new FetchBuilder("GET", qualifyUrl("/plugins/org.graylog.plugins.report/reports")).json().ignoreUnauthorized().build();
  return promise.then((response) => Object.fromEntries(response == null ? void 0 : response.reports.map((report) => [report.id, report]))).catch(() => ({}));
};
export default fetchReports;
